import React, { Suspense } from 'react';
import { ILiveblog } from '@sky-it-cmscomposer/liveblog-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel, IGenericObject } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const LiveblogContainerWrapper = React.lazy(() => import('./liveblog-container'));

interface IDynamicLiveblogContainerWrapper extends IComponentModel<ILiveblog | {}> {
    model?: ILiveblog | {};
    query?: unknown;
    config?: IGenericObject;
}

const DynamicLiveblogContainer: React.FC<IDynamicLiveblogContainerWrapper> = ({
    /* istanbul ignore next: default value on mandatory field */ model = {},
    /* istanbul ignore next: default value */ query = {},
    /* istanbul ignore next: default value */ children = null,
    /* istanbul ignore next: default value */ config = {},
}) => (
    <Suspense fallback={<HtmlWrapper html={children} />}>
        <LiveblogContainerWrapper initialModel={validateModel(model) as ILiveblog} query={validateModel(query)} config={config} />
    </Suspense>
);

/**
 * NOTE: YOU HAVE TO to specify default props to be derived from web-component attributes
 */
DynamicLiveblogContainer.defaultProps = {
    children: null,
    model: {} as ILiveblog,
    query: {},
    config: {},
};

export default DynamicLiveblogContainer;
